import React from "react";
import { IconContext } from "react-icons";
import {iconInstanceMd} from "../../../utils/editorUtils";
function Icons({ Icon, Config }) {
  const MdIcon = iconInstanceMd(Icon);
  return (
    <IconContext.Provider value={{ ...Config }}>
      <MdIcon />
    </IconContext.Provider>
  );
}
export default Icons;
